import { render } from "./TagSelect.vue?vue&type=template&id=1ec85c40&scoped=true"
import script from "./TagSelect.vue?vue&type=script&lang=js"
export * from "./TagSelect.vue?vue&type=script&lang=js"

import "./TagSelect.vue?vue&type=style&index=0&id=1ec85c40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec85c40"]])

export default __exports__